import { NewLoginWidgetContextType } from './../models/new-login-widget-types';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'mem-okta-login-footer',
  templateUrl: './new-login-widget-footer.component.html',
  styleUrls: ['./new-login-widget-footer.component.scss']
})
export class NewLoginWidgetFooterComponent implements OnInit {

  @Input('pageType') pageType: NewLoginWidgetContextType = { controller: 'primary-auth' }

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/new-login-widget/new-login-widget-footer/new-login-widget-footer.component.ts